import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Unauthenticated from 'Components/ComponentLibrary/Templates/Unauthenticated';
import classNames from 'classnames';
import Content from './Content';

const styles = () => ({
  root: {},
  formRoot: {
    padding: 0,
  },
});

const PasswordResetEmailForm = ({
  className,
  classes,
}) => {
  return (
    <Unauthenticated
      className={classNames(classes.root, className)}
      test={'authentication-step-reset-password'}
    >
      <Content />
    </Unauthenticated>
  );
};

PasswordResetEmailForm.defaultProps = {
  className: '',
};

PasswordResetEmailForm.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PasswordResetEmailForm);
